<div class="image-url-field full">
  <div class="preview" *ngIf="imageSrc as src">
    <img [src]="src" [alt]="label" (error)="onImageError($event)" />
  </div>
  <mat-form-field appearance="outline" class="full">
    <mat-label>{{ label }}</mat-label>
    <input matInput [formControlName]="controlName" placeholder="Paste URL or upload an image" />
  </mat-form-field>
  <div class="actions">
    <input #fileInput type="file" accept="image/jpeg,image/png,image/webp,image/gif" hidden (change)="onFileSelected($event)" />
    <button mat-stroked-button type="button" (click)="fileInput.click()" [disabled]="uploading || !challengeId">
      Upload image
    </button>
  </div>
  <mat-progress-bar *ngIf="uploading" mode="indeterminate"></mat-progress-bar>
  <p class="error" *ngIf="uploadError">{{ uploadError }}</p>
</div>